// i18n namespace "hero" (WP-A). Positioning A (COO decision 1), trimmed to 7 words
// per the 2026-10-09 re-score (fix 12, COO sign-off). The H1 is split
// into `title` + `titleTail` (rendered in one <h1>, the tail in a lighter tone).
// `{{years}}` comes from combinedYears() in src/content/team.ts (renders 40).

export const en = {
  title: "Senior SAP teams",
  titleTail: "for Mexico and the Americas.",
  lead: "Finance, logistics and e-invoicing on SAP S/4HANA, led by consultants with {{years}}+ years of combined experience. We also build AI assistants that work inside your SAP.",
  cta: "Talk to an SAP expert",
  secondary: "Meet the team",
  ledger: {
    caption: "Where our consultants have delivered SAP",
    finance: "Finance",
    logistics: "Logistics",
    assets: "Assets and people",
    platform: "Platform",
    serviceAi: "Service AI",
  },
};

export const es = {
  title: "Equipos SAP senior",
  titleTail: "para México y las Américas.",
  lead: "Finanzas, logística y facturación electrónica en SAP S/4HANA, con consultores que suman más de {{years}} años de experiencia. También creamos asistentes de IA que trabajan dentro de tu SAP.",
  cta: "Habla con un experto SAP",
  secondary: "Conoce al equipo",
  ledger: {
    caption: "Dónde han entregado SAP nuestros consultores",
    finance: "Finanzas",
    logistics: "Logística",
    assets: "Activos y personas",
    platform: "Plataforma",
    serviceAi: "IA para servicio",
  },
};

export const fr = {
  title: "Des équipes SAP seniors",
  titleTail: "pour le Mexique et les Amériques.",
  lead: "Finance, logistique et facturation électronique sur SAP S/4HANA, menées par des consultants qui cumulent plus de {{years}} ans d’expérience. Nous créons aussi des assistants IA qui travaillent dans votre SAP.",
  cta: "Parler à un expert SAP",
  secondary: "Rencontrer l’équipe",
  ledger: {
    caption: "Là où nos consultants ont livré SAP",
    finance: "Finance",
    logistics: "Logistique",
    assets: "Actifs et personnes",
    platform: "Plateforme",
    serviceAi: "IA de service",
  },
};

export const pt = {
  title: "Equipes SAP sênior",
  titleTail: "para o México e as Américas.",
  lead: "Finanças, logística e faturamento eletrônico no SAP S/4HANA, liderados por consultores com mais de {{years}} anos de experiência somada. Também criamos assistentes de IA que trabalham dentro do seu SAP.",
  cta: "Fale com um especialista SAP",
  secondary: "Conheça a equipe",
  ledger: {
    caption: "Onde nossos consultores entregaram SAP",
    finance: "Finanças",
    logistics: "Logística",
    assets: "Ativos e pessoas",
    platform: "Plataforma",
    serviceAi: "IA de atendimento",
  },
};
